import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { NewbuildingDecoration } from 'shared/components/NewbuildingDecorationsRedesign';
import { DecorationInHouseItemsRedesign } from 'shared/containers/NewbuildingDecorations/DecorationInHouseItemsRedesign';
import { trackShowNewbuildingDecoration } from 'shared/containers/NewbuildingDecorations/tracking';
import { getDecorationsBanner } from 'shared/selectors/newObject/getDecorationsBanner';
import { getDecorationsInHouse } from 'shared/selectors/newObject/getDecorationsInHouse';

import { DecorationItemsRedesign } from './DecorationItemsRedesign';
import { NewbuildingCurrentDecorationContainer } from './NewbuildingCurrentDecoration';
import { NewbuildingDecorationBannerContainer } from './NewbuildingDecorationBanner';
import { getNewbuildingDecorations } from '../../selectors/newObject';

export const NewbuildingDecorationRedesignContainer = () => {
  const decorationsInHouse = useSelector(getDecorationsInHouse);
  const decorationsInNewbuilding = useSelector(getNewbuildingDecorations);
  const isBannerApplied = Boolean(useSelector(getDecorationsBanner));

  return (
    <ActionAfterViewObserver callback={trackShowNewbuildingDecoration} triggerOnce={true}>
      <>
        {!isBannerApplied && <NewbuildingCurrentDecorationContainer />}
        <NewbuildingDecorationBannerContainer />
        {!!decorationsInHouse.length && (
          <NewbuildingDecoration title="Отделка в доме" items={<DecorationInHouseItemsRedesign />} />
        )}
        {!!decorationsInNewbuilding.length && (
          <NewbuildingDecoration title="Отделка в ЖК" items={<DecorationItemsRedesign />} />
        )}
      </>
    </ActionAfterViewObserver>
  );
};
